<template>
    <v-dialog v-model="dialog" :persistent="!dismissible" max-width="500">
        <v-card>
            <v-card-title :class="[{ 'error-title': alertMode }]">
                <h3 class="title">{{ title }}</h3>
                <v-spacer></v-spacer>
                <v-icon size="18" v-if="dismissible" @click="hide">fas fa-times</v-icon>
            </v-card-title>
            <v-card-text v-if="content">
                <p v-html="content"></p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="loading" :loadingCancel="loadingCancel" small depressed v-if="dismissible"
                    class="normal-btn" @click.stop="onCancel">{{ cancelLabel || $t('common.cancel') }}
                </v-btn>
                <v-btn :disabled="loadingCancel" :loading="loading" small
                    :class="['normal-btn', { 'black--text': !alertMode }]" depressed
                    :color="alertMode ? 'error' : 'primary'" @click.stop="onConfirm">
                    {{ confirmLabel || $t('common.confirm') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
    props: ['title', 'content', 'persistent', 'closeOnConfirm', 'closeOnCancel', 'loading', 'loadingCancel', 'cancelLabel', 'confirmLabel', 'alertMode'],
    data() {
        return {
            dialog: false
        }
    },
    computed: {
        ...mapState(['dialogActive', 'secondDialogActive']),
        dismissible() {
            var vm = this
            return !(vm.persistent === true)
        }
    },
    methods: {
        ...mapMutations(['setDialogActive', 'setSecondDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.isSecondDialog ? vm.setSecondDialogActive(true) : vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.isSecondDialog ? vm.setSecondDialogActive(false) : vm.setDialogActive(false)
        },
        onConfirm() {
            this.$emit('confirm')
            if (this.closeOnConfirm !== false) {
                this.hide()
            }
        },
        onCancel() {
            this.$emit('cancel')
            if (this.closeOnCancel !== false) {
                this.hide()
            }
        }
    },
    watch: {
        dialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
        secondDialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
        dialog(newVal) {
            this.$emit('change', newVal)
        }
    }
}
</script>

<style scoped>
.error-title {
    background-color: var(--v-error-base);
    color: white;
    margin-bottom: 10px;
}
</style>